import { createContext, useContext } from "react";
import type { UsePwaUpdateResult } from "./usePwaUpdate";
import type {
  AppInformation,
  ComponentRelease,
  Release,
} from "./release-information";
export type CheckStatus =
  | "idle"
  | "checking"
  | "downloading"
  | "ready"
  | "current"
  | "offline"
  | "failed"
  | "unsupported";
export interface AppUpdateState extends UsePwaUpdateResult {
  information: AppInformation | null;
  frontend: ComponentRelease | null;
  status: CheckStatus;
  required: boolean;
  inFlight: number;
  announcements: { component: string; release: Release }[];
  dismissAnnouncements: () => void;
}
export const UpdateContext = createContext<AppUpdateState | null>(null);
/** Every application consumer shares a single worker owner above the router. */
export function usePwaUpdate(): AppUpdateState {
  const state = useContext(UpdateContext);
  if (!state) throw new Error("AppUpdateProvider is missing");
  return state;
}
